import { Card, Image, Space, Typography } from 'antd'
import { observer } from 'mobx-react'
import useStore from '@/hooks/useStore'

const { Title, Text } = Typography

function DetailsCard(props) {
  const { imgSrc, name, info1, info2, idlFcltUnqNo, flrNo, hoCnt, brtitleinfoUnqNo } = props
  const facilityStore = useStore('facilityStore')
  const clickImg = () => {
    facilityStore.getFacilityInfo(imgSrc, name, info1, info2, idlFcltUnqNo, flrNo, hoCnt, brtitleinfoUnqNo)
  }
  return (
    <Card style={{ width: '100%' }}>
      <div>
        <Image width={'100%'} style={{ borderRadius: 20, cursor: 'pointer' }} src={imgSrc} preview={false} onClick={clickImg}/>
        <Title level={4}>{name}</Title>
        <Space size={[24, 4]} wrap>
          <div>
            면적&nbsp;&nbsp;<Text style={{ fontWeight: 'bold' }}>{info1}</Text>
          </div>
          <div>
            규모&nbsp;&nbsp;<Text style={{ fontWeight: 'bold' }}>{info2}</Text>
          </div>
        </Space>
      </div>
    </Card>
  )
}

export default observer(DetailsCard)
